export default __webpack_public_path__ + "static/media/howToaddProductCheckout.898f46b6.png";